import { useCallback } from 'react';

import { client } from 'core/http';

export default function useAxleDeletes() {
  return useCallback((axleId, vehicleId) => {
    return client()
      .delete(`vehicles/${vehicleId}/axles/${axleId}`)
      .then(response => response.data);
  }, []);
}
